import CardDesignerCardElementDragControls from './CardDesignerCardElementDragControls';

export default CardDesignerCardElementDragControls;
